import firebase from 'firebase/app';
import 'firebase/firestore';

firebase.initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_CONF));
// Initialize Cloud Firestore and get a reference to the service
export default firebase;